import React, {FC} from "react";
import {ProjectMapped, ProjectType, translateProjectType} from "api-client";
import {Image} from "components/common";
import factoringIcon from 'assets/images/svg/project-types/factoring.svg';
import projectIcon from 'assets/images/svg/project-types/project.svg';
import socialIcon from 'assets/images/svg/project-types/social.svg';
import styles from './ProjectTypeBadge.module.scss';

const TYPE_ICONS: Record<ProjectType, string> = {
  [ProjectType.LOAN]: factoringIcon,
  [ProjectType.PROJECT]: projectIcon,
  [ProjectType.SOCIAL]: socialIcon,
  [ProjectType.DEBT]: factoringIcon,
};

interface Props {
    type?: ProjectType;
}

const ProjectTypeBadge: FC<Props> = ({type}) => {
  if (!type || !ProjectMapped[type]) return null;

  const label = translateProjectType(type);

  return (
    <span className={styles.projectTypeBadge}>
      <Image className={styles.projectTypeBadge__icon} src={TYPE_ICONS[type]} alt={label}/>
      <span className={styles.projectTypeBadge__tooltip} aria-hidden="true">{label}</span>
    </span>
  );
};

export default ProjectTypeBadge;
